var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1386 2898h828v72h-828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1535.7 1926c8.6406 27.504 30.312 125.21 30.312 414 0 325.3-142.78 493.27-169.67 522h807.34c-26.891-28.727-169.67-196.7-169.67-522 0-289.51 21.816-387.04 30.277-414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2389.2 3330h-1178.4c-24.121 21.602-40.789 50.004-40.789 77.832 0 56.34 49.246 102.17 109.8 102.17h1040.4c60.551 0 109.8-45.828 109.8-102.17 0-27.828-16.703-56.23-40.789-77.832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2095.5 1890 82.547-82.547v-313.45h-180v54h-108v-54h-180v54h-108v-54h-180v313.45l82.547 82.547zm-205.45-270h108v90h-108zm-288 0h108v90h-108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1252.9 3266.4c11.305 8.4609 19.223 14.688 22.824 27.574h1048.5c3.6016-12.887 11.52-19.117 22.824-27.574 20.914-15.625 46.941-35.066 46.941-98.426 0-66.059-61.488-97.309-110.95-122.4-25.414-12.887-49.57-25.344-61.414-39.602h-842.98c-11.773 14.688-36.395 27.254-62.207 40.285-49.215 24.875-110.45 55.801-110.45 121.71 0 63.359 26.027 82.801 46.945 98.426z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRookIcon);
export default __webpack_public_path__ + "static/media/rookIcon.9dbbfeb3cc837a392535638901b5a558.svg";
export { ForwardRef as ReactComponent };